export default __webpack_public_path__ + "static/media/quickstart-step-8.9e1eccd5.jpg";